<template>
  <v-card v-if="partners.length" max-width="720">
    <domain-image
      position="center center"
      height="100"
      width="100%"
      class="mt-4 ml-4"
    ></domain-image>
    <v-card-text v-if="!success">
      <v-form v-model="valid">
        <v-autocomplete
          :items="branches"
          item-text="BranchAddress"
          filled
          :rules="rules"
          v-model="callout.Branch_ID"
          item-value="Branch_ID"
          @change="onBranchSelect()"
          label="Επιλέξτε Κτήριο"
        >
          <template v-slot:item="data">
            <v-list-item-content>
              <v-list-item-title>
                {{ data.item.BranchAddress }}, {{ data.item.BranchDimosName }}
              </v-list-item-title>
              <v-list-item-subtitle>
                {{ data.item.PartnerBrandName }}</v-list-item-subtitle
              >
            </v-list-item-content>
          </template>
        </v-autocomplete>
        <v-autocomplete
          :rules="rules"
          filled
          item-value="Project_ID"
          v-if="callout.Branch_ID"
          :items="projects"
          item-text="ProjectName"
          v-model="callout.Project_ID"
          :label="'Επιλέξτε '+ $unitText('Ανυψωτικό')"
          v-tooltip="
            'Εάν δεν γνωρίζετε σε ποιόν βρίσκετε η βλάβη αφήστε την προεπιλογή'
          "
        >
          <template v-slot:item="data">
            <v-list-item-content>
              <v-list-item-title>
                {{ data.item.ProjectName }}</v-list-item-title
              >
            </v-list-item-content>
          </template>
        </v-autocomplete>
        <v-text-field
          filled
          v-model="callout.WhoAnnounced"
          type="text"
          label="Το όνομα σας"
        >
        </v-text-field>
        <v-textarea
          :rules="rules"
          filled
          label="περιγραφή βλάβης"
          v-model="callout.CalloutDescription"
          :disabled="callout.Project_ID === null && callout.Branch_ID === null"
        >
        </v-textarea>
        <v-btn
          color="callout"
          dark
          :disabled="!valid"
          @click="newCallout()"
          large
          >ΑΠΟΣΤΟΛΗ ΒΛΑΒΗΣ</v-btn
        >
      </v-form>
    </v-card-text>

    <v-card-text v-else class="text-center">
      <v-icon color="green" size="100">mdi-check</v-icon>
      <h2>Η βλάβη στάλθηκε στο γραφείο.</h2>
      <v-btn color="secondary" to="/" class="mt-4" dark>
        Επιστροφή στην αρχική</v-btn
      >
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import { BranchDetails } from "../../../wl-core/api/classes/BranchDetails";
import DomainImage from "@/components/DomainImage";

export default {
  name: "NewCallout",
  components: { DomainImage },
  data: () => ({
    valid: true,
    rules: [(v) => !!v || "Δεν έχει συμπληρωθεί το πεδίο"],
    callout: {
      Partner_ID: null,
      Contact_ID: null,
      Branch_ID: null,
      Project_ID: null,
      CalloutDescription: "",
      Stopped: false,
      WhoAnnounced: "",
    },
    projects:[],
    success: false,
  }),
  created() {
    this.getPartnerDetails();
    this.callout.Contact_ID = this.userDetails.Contact_ID;
    this.fillDefault();
  },
  watch: {
    branches: function () {
      if (this.branches.length === 1) {
        this.fillDefault()
      }
    },
  },
  computed: {
    isAllFilled() {
      let callout = this.callout;
      return (
        !callout.Branch_ID ||
        !callout.Partner_ID ||
        !callout.Project_ID ||
        !callout.CalloutDescription
      );
    },
    ...mapGetters(["userDetails", "branches", "partners"]),
  },
  methods: {
    ...mapActions(["addCallout", "getPartnerDetails"]),

    fillDefault(){
      if (this.branches.length === 1) {
        const branch  = this.branches[0];
        this.callout.Branch_ID  = branch.Branch_ID;
        this.callout.Partner_ID = branch.Partner_ID;
        this.projects = branch.Projects;
        this.callout.Project_ID = this.projects[0].Project_ID
      }
    },
    newCallout() {
      this.addCallout(this.callout).then((resp) => {
        this.success = true;
      });
    },
    onBranchSelect() {
      const branch = this.branches.find((b) => b.Branch_ID === this.callout.Branch_ID);
      this.projects = branch.Projects
      this.callout.Project_ID = this.projects[0].Partner_ID
      this.callout.Partner_ID = branch.Partner_ID;
    },
  },
};
</script>
<style scoped>
</style>
